export enum TravelRecruitingFlags {
    JobsGridSendJobsButton = 'GT_JOB_GRID_SENDJOBS_BUTTON',
    DisableButtonOnSubmit = 'GT_DISABLE_BTN_ONSUBMIT',
    CandidateNotesEnabled = 'GT_CANDIDATE_NOTES_ENABLED',
    UpdateSendJobsSelectionText = 'GT_UPDATE_SENDJOBS_TEXT',
    FacilityGridTypeNameColumn = 'GT_FACILITY_GRID_TYPE_NAME_COLUMN',
    AcctMgrAyaPaidBonus = 'gt-ayapaid-bonus-acctmgr',
    LeadQueueWorkforceDisruptionLob = 'gt-leadqueue-wfd-lob',
    SearchAllCandidatesEmploymentType = 'gt-search-all-candidates-employment-type',
    FixProfileEmploymentType = 'gt-profile-employmenttype-fix',
    UseNewProfileTags = 'gt-profile-new-category-tags'
}
